module.exports = __webpack_public_path__ + "img/environmental.6802f304.jpg";